// I tipi che il tavolo della scopa legge. La TMA NON importa QScopa: sono copiati A MANO da Qlash-IT/QScopa @ f1bede79fa273d917d2702301a6de6f7fab43c16
// (main, 2026-10-18), uno per file:
//   · Modo, Fase, MotivoFine, Config, Voci, Riepilogo, Vista, CodiceErrore — packages/regole/src/tipi.ts (la Vista e quella del motore: MAI le carte in mano agli
//     altri, MAI l'ordine del mazzo; degli altri si sa solo QUANTE carte hanno, `carteInMano`). `Stato` e `Azione` del motore NON si copiano: sono del server.
//   · AzioneDiPersona — packages/regole/src/tipi.ts `AzioneGioca` + apps/qscopa-gameserver/src/regole.ts `puòAgire`: le chiavi sono ESATTAMENTE `carta`, `posto`,
//     `prendi`, `tipo` (un'altra chiave e `AZIONE_MALFORMATA`); `distribuisci` e `abbandono` sono del server (`AZIONE_DEL_SERVER`).
//   · MOTIVI — apps/qscopa-gameserver/src/regole.ts `MOTIVI` (i sotto-codici che un rifiuto puo portare in `reason`).
//   · La busta del trasporto (PostoPubblico, StatoDelPosto, EsitoPerLinea, gli eventi, il commit e il seed) NON e piu qui: sta in `lib/gamehost/protocol.ts` (CORE.lock), e qui si
//     ri-esportano i nomi che la scopa usa o si specializzano sulla sua `Vista` (`StatoDelPosto`).
// Le carte sono INTERI 0..39 (`seme * 10 + grado - 1`): v. `lib/scopa/regole.ts` e, per il disegno, `lib/tavolo/carta.ts`.

import type { Posto, StatoDelPosto as StatoDelPostoComune } from '@/lib/gamehost/protocol';

// la busta del trasporto sta in `lib/gamehost/protocol.ts`: qui si ri-esportano i nomi che la scopa usa
export type { EsitoPerLinea, Posto, PostoPubblico } from '@/lib/gamehost/protocol';

/** Una linea (chi segna insieme: il giocatore nella scopa, la coppia {0,2} o {1,3} nello scopone). Il posto e il `Posto` del trasporto (0..3). */
export type Linea = number;
export type Carta = number;
export type Modo = 'scopa' | 'scopone';
export type Fase = 'da-distribuire' | 'in-gioco' | 'finita';
export type MotivoFine = 'punteggio' | 'spareggio' | 'ultima-presa';

export interface Config {
  readonly modo: Modo;
  readonly traguardo: number;
  readonly scelta: 'giocatore' | 'meno-carte';
  readonly soglia: 'superata' | 'raggiunta';
  readonly ultimaPresaPrendeResto: boolean;
  readonly ridistribuisciTreRe: boolean;
  readonly maxRidistribuzioni: number;
  readonly primieraSemeMancante: 'esclude' | 'zero';
  readonly mazziereIniziale: Posto;
  readonly partita: 'amichevole' | 'eliminazione';
  readonly maxSpareggi: number;
}

export interface Voci {
  readonly scope: readonly number[];
  readonly carte: readonly number[];
  readonly denari: readonly number[];
  readonly settebello: readonly number[];
  readonly primiera: readonly number[];
}

export interface Riepilogo {
  readonly smazzata: number;
  readonly mazziere: Posto;
  readonly scope: readonly number[];
  readonly carte: readonly number[];
  readonly denari: readonly number[];
  readonly settebello: Linea | null;
  readonly primiera: { readonly valori: readonly (number | null)[]; readonly vincitore: Linea | null };
  readonly voci: Voci;
  readonly punti: readonly number[];
  readonly spareggio: number;
  readonly nonAssegnate: readonly Carta[];
}

/** Quello che UN posto vede: la sua mano, quante carte hanno gli altri, il tavolo, le prese (pubbliche: giocate scoperte), i punti. */
export interface Vista {
  readonly posto: Posto;
  readonly linea: Linea;
  readonly config: Config;
  readonly fase: Fase;
  readonly smazzata: number;
  readonly mazziere: Posto;
  readonly ridistribuzioni: number;
  readonly turno: Posto;
  readonly punteggio: readonly number[];
  readonly miaMano: readonly Carta[];
  readonly carteInMano: readonly number[];
  readonly carteNelMazzo: number;
  readonly tavolo: readonly Carta[];
  readonly prese: readonly (readonly Carta[])[];
  readonly scope: readonly number[];
  readonly riepiloghi: readonly Riepilogo[];
  readonly vincitore: Linea | null;
  readonly spareggio: number;
  readonly motivoFine: MotivoFine | null;
}

export type CodiceErrore =
  | 'FASE_ERRATA'
  | 'PARTITA_FINITA'
  | 'FUORI_TURNO'
  | 'CARTA_NON_IN_MANO'
  | 'PRESA_OBBLIGATORIA'
  | 'UGUALE_PRIMA_DELLA_SOMMA'
  | 'NON_LE_MENO_CARTE'
  | 'PRESA_NON_VALIDA'
  | 'ORDINE_NON_VALIDO'
  | 'AZIONE_SCONOSCIUTA';

/** I sotto-codici che il game host puo mettere in `reason` di un rifiuto (le prese). La frase la sceglie la TMA. */
export const MOTIVI: readonly CodiceErrore[] = ['PRESA_OBBLIGATORIA', 'UGUALE_PRIMA_DELLA_SOMMA', 'NON_LE_MENO_CARTE', 'PRESA_NON_VALIDA', 'CARTA_NON_IN_MANO'];

/** La SOLA azione di una persona: gioca una carta e prende quelle carte del tavolo (vuoto = la scarta). */
export interface AzioneDiPersona {
  tipo: 'gioca';
  posto: Posto;
  carta: Carta;
  prendi: Carta[];
}

/** Cio che il game host manda a UN posto a ogni `table:state`: la SUA proiezione, con la `Vista` della scopa. `vista` e null finche il tavolo non e completo (e prima della prima distribuzione). */
export type StatoDelPosto = StatoDelPostoComune<Vista>;
